import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { getPrescriptionType, hasVisitedStepPrescription } from '../../../../state/configurator/selectors.js';
import { useRxGlassesConfiguratorContext } from '../../../Context/RxGlassesConfiguratorContext.js';
import useConfigurationSummary from '../../../hooks/use-configuration-summary.js';
import DesktopConfigurationSummary$1 from './DesktopConfigurationSummary.js';

const DesktopConfigurationSummaryContainer = ()=>{
    const { getLabel  } = useIntl();
    const prescriptionType = useSelector(getPrescriptionType);
    const { id  } = useRxGlassesConfiguratorContext();
    const hasVisitedStepPrescription$1 = useSelector((s)=>hasVisitedStepPrescription(s, {
            id
        })
    );
    const { frame , lensType , lensPackage , addOn , bundlePrice , hasVisitedStepAddOn , hasVisitedStepLensPackage ,  } = useConfigurationSummary();
    const labels = React.useMemo(()=>({
            lensType: getLabel('products.glasses.configurator.lensType'),
            lensPackage: getLabel('products.glasses.configurator.lensPackage'),
            addOn: getLabel('products.glasses.configurator.addOn'),
            totalPrice: getLabel('products.glasses.configurator.totalPrice'),
            zeroPrice: getLabel('products.glasses.configurator.priceIsZero')
        })
    , [
        getLabel
    ]);
    const isPhone = MediaQuery.useIsPhone();
    return /*#__PURE__*/ React.createElement(DesktopConfigurationSummary$1, {
        frame: frame,
        lensType: lensType,
        lensPackage: lensPackage,
        addOn: addOn,
        bundlePrice: bundlePrice,
        labels: labels,
        isPhone: isPhone,
        hasVisitedStepLensPackage: hasVisitedStepLensPackage,
        hasVisitedStepAddOn: hasVisitedStepAddOn,
        prescriptionType: prescriptionType,
        hasVisitedStepPrescription: hasVisitedStepPrescription$1
    });
};
var DesktopConfigurationSummary = DesktopConfigurationSummaryContainer;

export { DesktopConfigurationSummary as default };
//# sourceMappingURL=DesktopConfigurationSummaryContainer.js.map
